import { SnackbarKey, closeSnackbar } from "notistack";
import * as React from "react";

import { CloseIconButton } from "veneer/IconButton";

export default function getCloseIcon(key: SnackbarKey) {
  return (
    <CloseIconButton
      contrast
      iconSize="small"
      onClick={() => {
        closeSnackbar(key);
      }}
    />
  );
}
